var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center m-b-20" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("工作量概况"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "b-r-4 m-b-24 p-24 text-center",
          staticStyle: { background: "#DCEEFE" },
        },
        [
          _c("div", { staticClass: "font-28 cor-66" }, [
            _vm._v(" 预估处理凭证数量"),
          ]),
          _c("div", { staticClass: "cor-66 m-t-24 m-b-20 font-20" }, [
            _c(
              "span",
              { staticClass: "font-32 cor-33 font-weight-bold m-r-4" },
              [_vm._v(_vm._s(_vm.boardData.ticketNum))]
            ),
            _vm._v("张"),
          ]),
          _c("div", { staticClass: "font-24 cor-66" }, [
            _vm._v("注:根据系统中审核通过的审批流程进行预估，仅供参考"),
          ]),
        ]
      ),
      _c("div", {
        ref: "gzlPie",
        staticStyle: { width: "90vw", height: "280px" },
        attrs: { id: "gzlPie" },
      }),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-b-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("付款详情"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "flex row-between p-b-20" }, [
        _c(
          "div",
          {
            staticClass:
              "width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
          },
          [
            _vm._m(0),
            _c("div", [
              _c("div", [
                _c("span", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData?.paymentAll)),
                ]),
                _c("span", { staticClass: "font-20" }, [_vm._v(" 笔")]),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("付款申请")]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
          },
          [
            _vm._m(1),
            _c("div", [
              _c("div", [
                _c("span", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData?.paymentActual)),
                ]),
                _c("span", { staticClass: "font-20" }, [_vm._v(" 笔")]),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("实际付款")]),
            ]),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-b-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("开票详情"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "flex row-between p-b-20" }, [
        _c(
          "div",
          {
            staticClass:
              "width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
          },
          [
            _vm._m(2),
            _c("div", [
              _c("div", [
                _c("span", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData?.invoiceAll)),
                ]),
                _c("span", { staticClass: "font-20" }, [_vm._v(" 笔")]),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("开票审批")]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
          },
          [
            _vm._m(3),
            _c("div", [
              _c("div", [
                _c("span", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData?.invoiceActual)),
                ]),
                _c("span", { staticClass: "font-20" }, [_vm._v(" 张")]),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("开票数量")]),
            ]),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-b-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("报销详情"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "flex row-between" }, [
        _c(
          "div",
          {
            staticClass:
              "width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
          },
          [
            _vm._m(4),
            _c("div", [
              _c("div", [
                _c("span", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData?.expenseAll)),
                ]),
                _c("span", { staticClass: "font-20" }, [_vm._v(" 笔")]),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("报销总笔数")]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
          },
          [
            _vm._m(5),
            _c("div", [
              _c("div", [
                _c("span", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData?.invoiceOrder)),
                ]),
                _c("span", { staticClass: "font-20" }, [_vm._v(" 张")]),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("发票数量")]),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "p-16" },
        _vm._l(_vm.boardData?.expenseMaps, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "flex col-center row-between p-t-18 p-b-18 p-l-10 p-r-10",
              staticStyle: { "border-bottom": "1px solid #d4d5de" },
            },
            [
              _c("div", { staticClass: "flex col-center" }, [
                _c("img", {
                  staticClass: "w-34 h-34 m-r-16",
                  attrs: {
                    alt: "rank",
                    src: require("@/assets/icon/employeeKanban/tablelogo.png"),
                  },
                }),
                _c("span", { staticClass: "font-28" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
              ]),
              _c("div", { staticClass: "flex col-center font-28" }, [
                _vm._v(_vm._s(item.value) + " " + _vm._s(item.unit)),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-b-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("其他事项"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex flex-wrap" },
        _vm._l(_vm.boardData?.others, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "m-12 p-t-16 p-b-16 bg-F5F9FF b-r-8 text-center width-46",
            },
            [
              _c("div", { staticClass: "font-40 font-weight-700 m-b-10" }, [
                _vm._v(_vm._s(item.cnt)),
                _c("span", { staticClass: "font-20" }, [_vm._v(" 次")]),
              ]),
              _c("div", { staticClass: "font-24" }, [
                _vm._v(_vm._s(item.label)),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "付款申请",
          src: require("@/assets/icon/employeeKanban/caiwu/fksq.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "实际付款",
          src: require("@/assets/icon/employeeKanban/caiwu/sjfk.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "开票审批",
          src: require("@/assets/icon/employeeKanban/caiwu/kpsp.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "开票数量",
          src: require("@/assets/icon/employeeKanban/caiwu/kpsl.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "报销总笔数",
          src: require("@/assets/icon/employeeKanban/caiwu/bxzbs.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "发票数量",
          src: require("@/assets/icon/employeeKanban/caiwu/fpsl.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }